(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_5f6e721"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nuvana-ugc-grid'))customElements.define('nuvana-ugc-grid',class extends HTMLElement{
 connectedCallback(){if(matchMedia('(prefers-reduced-motion:reduce)').matches)return;this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.classList.add('nv-ugc--arrive');this.observer.disconnect();}},{threshold:0,rootMargin:'0px 0px 80px 0px'});this.observer.observe(this);}
 disconnectedCallback(){this.observer?.disconnect();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_d6df2ae"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nuvana-faq'))customElements.define('nuvana-faq',class extends HTMLElement{
  connectedCallback(){
   this.controller?.abort();this.controller=new AbortController();this.states=new Map();if(this.querySelector('accordion-custom')){this.addEventListener('toggle',e=>{if(e.target.tagName!=='DETAILS'||!e.target.open||this.dataset.single!=='true')return;this.querySelectorAll('details[open]').forEach(d=>{if(d!==e.target)d.open=false})},{capture:true,signal:this.controller.signal});return;}
   this.addEventListener('click',e=>{const summary=e.target.closest('summary');if(!summary||!this.contains(summary))return;e.preventDefault();const d=summary.parentElement;const state=this.states.get(d);const open=!(state?state.open:d.open);if(open&&this.dataset.single==='true')this.querySelectorAll('details[open]').forEach(other=>{if(other!==d)this.toggle(other,false)});this.toggle(d,open)}, {signal:this.controller.signal});
  }
  toggle(d,open){d.open=open;}
  disconnectedCallback(){this.controller?.abort();this.states?.forEach(s=>s.animation?.cancel())}
 });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nuvana-rating"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nuvana-rating'))customElements.define('nuvana-rating',class extends HTMLElement{
 connectedCallback(){this.abort?.abort();this.abort=new AbortController();this.update=()=>{const source=document.querySelector('[data-nv-review-summary]');let data;try{data=JSON.parse(source?.textContent||'{}')}catch{return}const count=Number(data.count),rating=Number(data.rating);this.hidden=!(count>0&&rating>0);if(this.hidden)return;this.querySelector('a').href='#'+data.target;this.querySelector('[data-stars]').style.width=(rating/5*100)+'%';this.querySelector('[data-rating-copy]').textContent=rating.toFixed(1)+' · '+count.toLocaleString()+' '+(count===1?this.dataset.singular:this.dataset.plural);this.querySelector('a').setAttribute('aria-label',this.dataset.accessible.replace('[rating]',rating.toFixed(1)).replace('[count]',String(count)));};this.update();for(const event of ['DOMContentLoaded','shopify:section:load','shopify:section:unload','nuvana:reviews-updated'])document.addEventListener(event,()=>queueMicrotask(this.update),{signal:this.abort.signal});requestAnimationFrame(this.update);}
 disconnectedCallback(){this.abort?.abort();}
});
  } catch(e) { console.error(e); }
})();

})();
